import "./radio.css";
import { attachPropertiesToComponent } from '../../utils/attach-properties-to-component';
import { Group } from './group';
import { Radio } from './radio';
export default attachPropertiesToComponent(Radio, {
  Group
});